// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__SmDLG","amountTitle":"Form_amountTitle__eGwGY","sendDateOption":"Form_sendDateOption__GcmVu","sendDate":"Form_sendDate__pMIDl"};